/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {
    AddBoxOutlined,
    CollectionsOutlined,
    IndeterminateCheckBoxOutlined,
    ManageSearch,
    NotesOutlined
} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG,
    CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import {ESTADOANUNCIOS} from "../../Constantes";
import Dialogo_Tours from "../Dialogos/Dialogo_Tours";
import Dialogo_Tours_Especificaciones from "../Dialogos/Dialogo_Tours_Especificaciones";
import Dialogo_Tours_Incluye from "../Dialogos/Dialogo_Tours_Incluye";
import Dialogo_Tours_No_Incluye from "../Dialogos/Dialogo_Tours_No_Incluye";
import Dialogo_Tours_Galeria from "../Dialogos/Dialogo_Tours_Galeria";


const Seccion_Tours = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'tours'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Tours,
        titulo: 'Detalles del tour',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoEspecificaciones, abrir: abrirEspecificaciones} = useDialogo({
        Componente: Dialogo_Tours_Especificaciones,
        titulo: 'Especificaciones del tour',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoIncluye, abrir: abrirIncluye} = useDialogo({
        Componente: Dialogo_Tours_Incluye,
        titulo: 'Incluye en el tour',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoNoIncluye, abrir: abrirNoIncluye} = useDialogo({
        Componente: Dialogo_Tours_No_Incluye,
        titulo: 'No Incluye en el tour',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoGaleria, abrir: abrirGaleria} = useDialogo({
        Componente: Dialogo_Tours_Galeria,
        titulo: 'No Incluye en el tour',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'especificaciones':
                abrirEspecificaciones(data)
                break
            case 'incluye':
                abrirIncluye(data)
                break
            case 'noIncluye':
                abrirNoIncluye(data)
                break
            case 'galeria':
                abrirGaleria(data)
                break

        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoEspecificaciones/>

                <DialogoIncluye/>

                <DialogoNoIncluye/>

                <DialogoGaleria/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Tours'}
                        descripcion={`${numeroFilas} tours en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Tours

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        size: 40,
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'Categoria',
        direccion: 'left',
        propiedad: 'categoria',
        tipo: CASILLA_TEXTO
    },

    {
        nombre: 'Valor Tour',
        direccion: 'right',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOANUNCIOS
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Especificaciones',
        id: 'especificaciones',
        icono: NotesOutlined
    },
    {
        nombre: 'Incluye',
        id: 'incluye',
        icono: AddBoxOutlined
    },
    {
        nombre: 'No Incluye',
        id: 'noIncluye',
        icono: IndeterminateCheckBoxOutlined
    },
    {
        nombre: 'Galeria',
        id: 'galeria',
        icono: CollectionsOutlined
    }
]


